import React from 'react';
import { Table } from 'react-bootstrap';
import moment from 'moment';

const fmt = (v) => v != null ? v : '-';
const fmtDate = (d) => d ? moment(d).format('DD/MM/YYYY') : '-';

const PromissoriaDetalhe = ({ detalhe }) => {
  if (!detalhe) return null;

  return (
    <Table striped bordered hover size="sm">
      <tbody>
        <tr><th>Taxa de Juros</th><td>{fmt(detalhe.taxa_juros)}</td><th>Cotação</th><td>{fmt(detalhe.cotacao)}</td></tr>
        <tr><th>Moeda</th><td>{fmt(detalhe.moeda)}</td><th>Nosso Número</th><td>{fmt(detalhe.nosso_numero)}</td></tr>
        <tr><th>Data Baixa</th><td colSpan={3}>{fmtDate(detalhe.data_baixa)}</td></tr>
      </tbody>
    </Table>
  );
};

export default PromissoriaDetalhe;
